import React from 'react'
import { connect } from 'react-redux'
import styles from './Body.module.css';
import { getDateMDYY } from '_helpers'
import { PatientDot, CommonButton, ToolTipBulb } from '_components';
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import {
    PatientHomeAdmissionAuths,
    PatientHomeAdmissionPocs,
    PatientHomeAdmissionFoto,
    PatientHomeAdmissionRTM,
    PatientHomeAdmissionContraindications,
    PatientHomeAdmissionDiagnosis,
    PatientHomeAdmissionBenefits
} from 'PatientCareCenter/Home/Admissions';
import { faSpinner, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PatientHomeAdmissionBody extends React.Component {

    refreshLimberAssessment() {
        this.props.loadLimber(this.props.admission.id);
    }

    hepClicked() {
        this.props.openHEP(this.props.admission.id);
    }

    renderAssessmentsDisplay = (data) => {
        if (!data || data.length === 0) {
            return "";
        }

        // Sort assessments in reverse chronological order
        const sortedAssessments = [...data].sort(
            (a, b) => new Date(b.completedDate) - new Date(a.completedDate)
        );

        return (
            <div className={styles.limber_container}>
                <div className={styles.limber_header}>
                    Limber
                    <div className={styles.limber_header_icons}>
                        <img alt='Limber' className={styles.limber_badge} src='./images/limber.png' title="Limber" onClick={() => this.hepClicked()}></img>

                    </div>
                </div>

                <CommonButton className={styles.refresh_button} size='smaller' title='Refresh Limber Assessment'
                    onClick={() => this.props.loading ? null : this.refreshLimberAssessment()} >
                    <FontAwesomeIcon icon={faRefresh} color="white" className={this.props.loading ? styles.spinny : ''}></FontAwesomeIcon>
                </CommonButton>


                {sortedAssessments.map((assessment, index) => (
                    <div
                        key={index}
                        className={styles.limber_assessments}>
                        <div className={styles.limber_assessments_header}>
                            {new Date(assessment.completedDate).toLocaleDateString()} - {assessment.regionOfInjury} - {assessment.assessmentDisplayName}
                        </div>

                        {assessment.questionnaires.map((q) => (
                            <div
                                key={q.questionnaireId}
                                className={styles.limber_assessments_span1}>
                                <span
                                    className={styles.limber_assessments_span_internal}
                                    title={q.questionnaireDisplayName}
                                >
                                    {q.questionnaireDisplayName}
                                </span>

                                <span
                                    className={styles.limber_assessments_span2}
                                >
                                    Score: {q.score}
                                    {q.thresholdLabel ? ` (${q.thresholdLabel})` : ''}
                                </span>

                                <span
                                    className={styles.limber_assessments_span3}
                                >
                                    {q.crosswalkScore !== null && (
                                        <>
                                            <span
                                                data-tooltip-id={`tip-${q.questionnaireId}`}
                                                className={styles.limber_toolTip}
                                            >
                                                <ToolTipBulb position='right' width={350} size='extra-small'>
                                                    <b>{`${q.crosswalkLegacyMeasure} score: ${q.crosswalkScore}`}</b>
                                                </ToolTipBulb >
                                            </span>
                                        </>
                                    )}
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };


    render() {
        if (this.props.visible) {
            return (
                <div>
                    <div className={styles.body_wrapper}>
                        <div className={styles.body_left}>
                            <div className={styles.demog_table}>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>Start Date:</span>
                                    <span className={styles.demog_row_data}>{getDateMDYY(this.props.admission.startDate)}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>Onset Date:</span>
                                    <span className={styles.demog_row_data}>{getDateMDYY(this.props.admission.onsetDate)}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>DOT:</span>
                                    <span className={styles.demog_row_data}>
                                        <PatientDot id={this.props.admission.dot} className={styles.patient_dot} />{this.props.colorName}
                                    </span>
                                </div>


                                {Object.keys(this.props.insured)
                                    .map(id => {
                                        const i = this.props.insured[id];
                                        return (
                                            <div key={i.id} className={styles.demog_row}>
                                                <span className={styles.demog_row_header}>{i.position === 1 ? 'Payers:' : ''}</span>
                                                <span className={styles.demog_row_data} title={i.payerName + ' - ' + i.contractName}>
                                                    {i.position + ' - ' + i.payerName}
                                                </span>
                                            </div>
                                        )
                                    })
                                }

                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>Physician:</span>
                                    <span className={styles.demog_row_data}>{this.props.admission.physicianName}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}></span>
                                    <span className={styles.demog_row_data}>{this.props.admission.physicianPhone}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}></span>
                                    <span className={styles.demog_row_data}>{this.props.admission.physicianEmail}</span>
                                </div>


                            </div>

                            {Object.keys(this.props.caseMgrs)
                                .map(id => {
                                    const cm = this.props.caseMgrs[id];
                                    return (
                                        <div className={styles.demog_table} key={cm.id}>
                                            <div key={cm.id + '_name'} className={styles.demog_row}>
                                                <span className={styles.demog_row_header}>Case Manager:</span>
                                                <span className={styles.demog_row_data} title={cm.name}>{cm.name}</span>
                                            </div>
                                            <div key={cm.id + '_phone'} className={styles.demog_row}>
                                                <span className={styles.demog_row_data}></span>
                                                <span className={styles.demog_row_data} title={cm.phone}>{cm.phone}</span>
                                            </div>
                                            <div key={cm.id + '_email'} className={styles.demog_row}>
                                                <span className={styles.demog_row_data}></span>
                                                <span className={styles.demog_row_data} title={cm.email}>{cm.email}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            {Object.keys(this.props.insured)
                                .map(id => {
                                    const i = this.props.insured[id];
                                    return (
                                        <PatientHomeAdmissionAuths key={i.id} epno={i.epno} pyno={i.pyno} />
                                    )
                                })
                            }

                            <PatientHomeAdmissionPocs epno={this.props.admission.id} />

                            {this.props.limberActive &&
                                this.props.isFotoEpisodesExists &&
                                this.props.isFotoEpisodesExists.length > 0 && (
                                    <PatientHomeAdmissionFoto epno={this.props.admission.id} />
                                )}

                            {!this.props.limberActive && <PatientHomeAdmissionFoto epno={this.props.admission.id} />}
                            {(this.props.limberActive) ? this.props.loading ? (<FontAwesomeIcon icon={faSpinner} pulse />) : this.renderAssessmentsDisplay(this.props.limberAssessments) : ""}
                            <PatientHomeAdmissionBenefits epno={this.props.admission.id} />

                        </div>
                        <div className={styles.body_right}>
                            <PatientHomeAdmissionContraindications epno={this.props.admission.id} />
                            <PatientHomeAdmissionDiagnosis epno={this.props.admission.id} />
                        </div>
                    </div >
                    {this.props.rtmEnabled &&
                        <PatientHomeAdmissionRTM epno={this.props.admission.id} />
                    }
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadLimber: bindActionCreators(patientActions.loadLimberAssessments, dispatch),
        openHEP: bindActionCreators(patientActions.openHEP, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let limberActive = state.entities.admissions[ownprops.id]?.limberActive;

    let limberAssessments = Object.keys(state.entities.limberAssessments)
        .filter(x => state.entities.limberAssessments[x].epno === ownprops.id)
        .sort((a, b) => state.entities.limberAssessments[b].completedDate - state.entities.limberAssessments[a].completedDate)
        .map(x => state.entities.limberAssessments[x]);

    let loading = state.entities.admissions?.loading;
    let ptno = state.ui.admissions[ownprops.id].ptno;
    let isFotoEpisodesExists = Object.keys(state.entities.fotoEpisodes)
        .filter(x => state.entities.fotoEpisodes[x].EPNO === ownprops.epno || (state.entities.fotoEpisodes[x].EPNO === null && state.entities.fotoEpisodes[x].PTNO === ptno))
        .sort((a, b) => state.entities.fotoEpisodes[a].createDate - state.entities.fotoEpisodes[b].createDate)
        .map(x => state.entities.fotoEpisodes[x]);

    return {
        admission: state.entities.admissions[ownprops.id],
        colorName: state.entities.admissions[ownprops.id].dot ? state.entities.masterData.DOTCOLORS[state.entities.admissions[ownprops.id].dot].COLORNAME : undefined,
        visible: state.ui.admissions[ownprops.id].visible,
        insured: Object.keys(state.entities.insured)
            .filter(key => { return state.entities.insured[key].epno === ownprops.id })
            .sort((a, b) => state.entities.insured[a].position - state.entities.insured[b].position)
            .map(key => state.entities.insured[key]),
        caseMgrs: Object.keys(state.entities.caseMgrs)
            .filter(key => { return state.entities.caseMgrs[key].epno === ownprops.id })
            .sort((a, b) => state.entities.caseMgrs[a].position - state.entities.caseMgrs[b].position)
            .map(key => state.entities.caseMgrs[key]),
        //        rtmEnabled: state.entities.masterData.PROPS['RTM_ENABLED'] && state.entities.masterData.PROPS['RTM_ENABLED'].PRVALUE === 'true' ? true : false
        rtmEnabled: false,
        limberAssessments,
        loading,
        limberActive,
        ptno,
        isFotoEpisodesExists,
    };
}

const connectedPatientHomeAdmissionBody = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionBody);
export { connectedPatientHomeAdmissionBody as PatientHomeAdmissionBody };

